export default "__VITE_ASSET__CIdbKvmh__"